import { Component, Inject, OnInit } from '@angular/core';
import { IFileTransfer } from '../../../../models/common/file.transfer';
import { OregonWellDataService } from '../../../../services/oregon-well-data.service';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { IParameterResultsViewModel, SampleViewModel } from '../../../../models/well/samples/sample.viewmodel';
import { VoucherService } from '../../../../services/voucher-service';
import { Voucher } from '../../../../models/vouchers/voucher';
import { SharedService } from '@shared/services/shared.service';
import { AuthService } from '@shared/auth/auth.service';
import { DialogAddTreatmentComponent } from 'app/components/households/treatments/add/add-treatment-dialog';
import { DialogLinkTreatmentComponent } from '../link/link-treatment-dialog';

@Component({
  selector: 'app-edit',
  templateUrl: './edit-samples.component.html',
  styleUrls: ['./edit-samples.component.scss']
})
export class EditSampleComponent implements OnInit {
  // #region component

  sampleId: number = 0;
  sampleViewModel: SampleViewModel = undefined;

  contaminantMsg = "";
  exceedenceMsg = "";
  postError = false;
  postErrorMessages = [];
  errorMessages = [];
  processing = false;
  overrideDisabled = true;
  vouchers: Voucher[] = [];

  pdf: IFileTransfer;
  wellViewModel = this.oregonWellDataService.wellViewModel;

  // #endregion

  constructor(public oregonWellDataService: OregonWellDataService, 
              public authService: AuthService,
             @Inject(MAT_DIALOG_DATA) public data: number,
             private voucherService: VoucherService,
             private sharedService: SharedService, public dialog: MatDialog) {
    if (data != 0) {
      this.sampleId = this.data;
    }

    this.processing = true;
  }

  ngOnInit() { 
    this.loadSample();
  }

  ngAfterContentInit() {
    // ngAfterContentInit
  }



  editTreatment(treatmentId: number, housingUnitId: number) {
    const dialogRef = this.dialog.open(DialogAddTreatmentComponent, {
      width: '90%',
      data: {
        treatmentId: treatmentId,
        housingUnitId: housingUnitId
      }, 
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  linkTreatment() {
    const dialogRef = this.dialog.open(DialogLinkTreatmentComponent, {
      width: '90%',
      data: {
        voucherId: this.sampleViewModel.voucherId,
        treatmentId: 0
      }, 
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined && result > 0) {
        this.sampleViewModel.treatmentId = result;
        this.oregonWellDataService.showToastWarning("Treatment was linked to Sample.  This will not take effect until the sample is saved.");
      }
    });
  }

  unlinkTreatment() {
    this.sharedService.openConfirm("Are you sure you want to unlink this treatment from this sample?");
    this.sharedService.confirmed().subscribe( confirmed => {
      if(confirmed) {                
         this.sampleViewModel.treatmentId = 0;      
         this.oregonWellDataService.showToastWarning("Treatment was unlinked to Sample.  This will not take effect until the sample is saved.");
        
      }
    });
  }

  

  loadSample() {
    this.oregonWellDataService.GetEditSample(this.sampleId).subscribe(result => {
      this.sampleViewModel = result;
      //load the parameter results if needed
      if(this.sampleViewModel.sampleId == 0) {
        this.oregonWellDataService.GetParameterResults().subscribe(parameterResult => {
          this.sampleViewModel.parameterResults = parameterResult;
        },
          error => {
            this.oregonWellDataService.onHttpError(error);
          }
       );
      }

      if(this.sampleViewModel.wellId > 0) {
        this.voucherService.getVouchersByWellId(this.sampleViewModel.wellId).subscribe(voucherResult => {
          this.vouchers = voucherResult;
          this.setFormFields();
          this.processing = false;
        },
          error => {
            this.oregonWellDataService.onHttpError(error);
            this.setFormFields();
            this.processing = false;
          }
       );
      }
      else {
        this.setFormFields();
        this.processing = false;
      }
     
    },
      error => {
        this.oregonWellDataService.onHttpError(error);
        this.processing = false;
      },
      () => {
        this.oregonWellDataService.GetEditWell(this.sampleViewModel.wellId).subscribe(result => {
          this.wellViewModel = result;
        },
          error => {
            this.oregonWellDataService.onHttpError(error);
          }
        );
      }
    );
  }

  // #region form

  requestForm = new FormGroup({
    stampedDate: new FormControl(new Date()),
    collectionDate: new FormControl(new Date()),
    createDate: new FormControl(new Date()),
    testType: new FormControl(''),
  });

  setFormFields() {
    this.requestForm.get("stampedDate").setValue((new Date(this.sampleViewModel.stampedDate)));
    this.requestForm.get("collectionDate").setValue((new Date(this.sampleViewModel.collectionDate)));
    this.requestForm.get("createDate").setValue((new Date(this.sampleViewModel.createDate)));
    this.requestForm.get("testType").setValue((this.sampleViewModel.testType));
    this.ensureNumbersForParameterResults();
  }

  ensureNumbersForParameterResults() {
    
    for (let i = 0; i < this.sampleViewModel.parameterResults.length; i++) {
      //ensure all units are numbers
      if(this.sampleViewModel.parameterResults[i].parameterUnitId != undefined && this.sampleViewModel.parameterResults[i].parameterUnitId != null) {
        this.sampleViewModel.parameterResults[i].parameterUnitId = +this.sampleViewModel.parameterResults[i].parameterUnitId
      }
      //ensure all methods are numbers
      if(this.sampleViewModel.parameterResults[i].parameterMethodId != undefined && this.sampleViewModel.parameterResults[i].parameterMethodId != null) {
        this.sampleViewModel.parameterResults[i].parameterMethodId = +this.sampleViewModel.parameterResults[i].parameterMethodId
      }
      //ensure all labs are numbers
      if(this.sampleViewModel.parameterResults[i].parameterLabDetailsId != undefined && this.sampleViewModel.parameterResults[i].parameterLabDetailsId != null) {
        this.sampleViewModel.parameterResults[i].parameterLabDetailsId = +this.sampleViewModel.parameterResults[i].parameterLabDetailsId
      }
    }
  }

  getFormFields() {
    this.sampleViewModel.stampedDate = this.requestForm.value.stampedDate;
    this.sampleViewModel.collectionDate = this.requestForm.value.collectionDate;
    this.sampleViewModel.createDate = this.requestForm.value.createDate;
    this.sampleViewModel.testType = this.requestForm.value.testType;
    this.ensureNumbersForParameterResults();
  }

  // #endregion

  onSubmit(button: string) {
    this.processing = true;
    this.postError = false;


    if (button === "pdf") {
      const node = document.getElementById('pdfSample').innerHTML;
      const file: IFileTransfer = {
        download: this.oregonWellDataService.stripHtmlComments(node),
        download2: '',
        includePages: true
      }

      this.oregonWellDataService.DownloadPdf(file).subscribe(
        response => {
          this.pdf = response;
          this.processing = false;
        },
        error => {
          this.oregonWellDataService.onHttpError(error);
          this.processing = false;
        },
        () => {
          this.oregonWellDataService.downloadFile(this.pdf.download, "OregonWellData.pdf", true);
          this.processing = false;
        }
      );
    }
    else {
      this.getFormFields();
         
      this.oregonWellDataService.EditSample(this.sampleViewModel).subscribe(
        result => {
          this.postError = false;
          this.sampleViewModel = result;
          this.processing = false;
          this.postErrorMessages = [];
          this.exceedenceMsg = "";
        },
        error => {
          this.postError = true;
          this.processing = false;
          this.postErrorMessages = this.oregonWellDataService.onHttpError(error);
        },
        () => {
          this.oregonWellDataService.showToastSucess("Sample was Updated");
        }
      );
    }
  }

  // #region helpers

  addParameterResult() {
    const parameterResult: IParameterResultsViewModel = {
      parameterResultId: 0,
      parameterCompleteId:null,
      parameterResult: '',
      parameterUnitId:null,
      parameterMethodId: null,
      parameterLabDetailsId: null,
      parameterIsReTest:false,
      parameterExceedence:null,
      deleteParameterResult:false,
      analyte: ''
      
    };

    this.sampleViewModel.parameterResults.push(parameterResult);
  }

  removeParameterResult(id: number, parameterResultId: number) {
    if(parameterResultId != undefined) {
      
    
    this.sharedService.openConfirm("Are you sure you want to remove this test? You will still need to Update the sample to completely remove the test.");
    this.sharedService.confirmed().subscribe( confirmed => {
      if(confirmed) {        
        
      this.oregonWellDataService.lookupTestResultExceedance(parameterResultId).subscribe(result => {
        const lookupResult = result;

        if (lookupResult) {
          this.exceedenceMsg = "This Test has an Exceedance Letter generated and can not be Deleted";
          this.oregonWellDataService.showToastError("This Test has an Exceedance Letter generated and can not be Deleted");
        }
        else {
          this.sampleViewModel.parameterResults[id]["deleteParameterResult"] = true;
          this.sampleViewModel.parameterResults.splice(id, 1);
          this.exceedenceMsg = "";
        }
      },
        error => {
          this.oregonWellDataService.onHttpError(error);

          this.processing = false;
        },
        () => {
          this.contaminantChange();
        }
      );
      }
    });
    }
    else {
      this.sampleViewModel.parameterResults[id]["deleteParameterResult"] = true;
      this.sampleViewModel.parameterResults.splice(id, 1);
      this.exceedenceMsg = "";
    }
  }

  labChange(id, orelapId) {
    if (id === 0) {
      for (const i in this.sampleViewModel.parameterResults) {
        const temp = this.sampleViewModel.parameterResults[i] as any;
        temp.parameterLabDetailsId = orelapId;
      }
    }
  }

  contaminantChange() {
    const contaminants = [];

    for (const i in this.sampleViewModel.parameterResults) {
      const temp = this.sampleViewModel.parameterResults[i] as any;
      if (temp.parameterCompleteId !== null) {
        contaminants.push(temp.parameterCompleteId.toString());
      }
    }

    const duplicates = contaminants.filter((item, index) => contaminants.indexOf(item) !== index);

    if (duplicates.length !== 0) {
      this.contaminantMsg = "You have a duplicate Contaminant. Please verify you entered the correct Contaminant";
    }
    else {
      this.contaminantMsg = "";
    }
  }

  countyLookup(address, city, zip) {
    const lookup = address + "," + city + "," + zip;

    this.oregonWellDataService.lookupCountyLatLong(lookup).subscribe(result => {
      const data = result;
      this.sampleViewModel.lookupAddress = data[0];
      this.sampleViewModel.lookupCity = data[1];
      this.sampleViewModel.lookupState = "OR";
      this.sampleViewModel.lookupZip = data[2];
      this.sampleViewModel.wellCounty = data[3];
      this.sampleViewModel.wellLongitude = data[4];
      this.sampleViewModel.wellLatitude = data[5];
    },
      error => {
        this.oregonWellDataService.onHttpError(error);

        this.processing = false;
      }
    );
  }

  overrideLatLong() {
    this.overrideDisabled = !this.overrideDisabled;
  }

  // #endregion
}